import { ElementRef, forwardRef, ComponentProps } from "react";
import { Slot } from "@radix-ui/react-slot";
import { type VariantProps } from "class-variance-authority";
import { buttonVariants } from "~/components/ui/button";
import { cn } from "~/lib/utils";

// Custom Button component with forwardRef for Popover compatibility
const PopoverButton = forwardRef<
  HTMLButtonElement,
  React.ComponentProps<"button"> &
    VariantProps<typeof buttonVariants> & {
      asChild?: boolean;
    }
>(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      ref={asChild ? undefined : (ref as any)}
      data-slot="button"
      className={cn(
        buttonVariants({ variant, size }),
        "flex flex-row gap-1.5 items-center justify-start px-1 py-1.5 relative shrink-0 h-auto hover:bg-gray-100 transition-all duration-200 cursor-pointer rounded",
        className
      )}
      {...props}
    />
  );
});
PopoverButton.displayName = "PopoverButton";

const IconButton = forwardRef<
  ElementRef<typeof PopoverButton>,
  ComponentProps<typeof PopoverButton>
>(({ className, ...props }, ref) => (
  <PopoverButton
    ref={ref}
    {...props}
    className={cn(
      "disabled:opacity-50 disabled:cursor-not-allowed has-[>svg]:px-1.5 py-1.5",
      className
    )}
  />
));
IconButton.displayName = "IconButton";

export { PopoverButton, IconButton };
